import moment from "moment";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { LabeledIntArray } from "../../../models";
import { ReportService } from "../../../services/SubmissionService";
import { Card, CardContent, Stack } from "@mui/material";
export default function FilingBreakdownWidget() {
    const initalData: LabeledIntArray[] = [
        { name: "", value: [0, 0, 0] },
        { name: "", value: [0, 0, 0] },
        { name: "", value: [0, 0, 0] },
    ];
    const [monthlyReport, setMonthlyReport] = useState(initalData);
    useEffect(() => {
        ReportService.getLast90days({ attorneyId: "" }).then(
            (resp) => {
                setMonthlyReport(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);
    return (
        <Card sx={{ width: "100%" }}>
            <CardContent>
                <h4 className="header-title">Filing Breakdown</h4>
                <p className="text-muted mb-0">
                    {moment
                        .utc(new Date().setDate(new Date().getDate() - 30))
                        .local()
                        .format("DD MMM")}{" "}
                    - {moment.utc(Date.now()).local().format("DD MMM")} Showing
                    Data
                </p>
                <div dir="ltr">
                    <div
                        className="apex-charts"
                        data-colors="#526dee,#1abc9c,#f4bf3e"
                    >
                        <ReactApexChart
                            options={{
                                chart: {
                                    type: "radar",
                                    toolbar: {
                                        show: false,
                                    },
                                },
                                stroke: {
                                    width: 0,
                                },
                                fill: {
                                    opacity: 0.4,
                                },
                                markers: {
                                    size: 0,
                                },
                                legend: {
                                    show: true,
                                },
                                colors: ["#727cf5", "#18c984", "#f672a7"],
                                labels: ["30 Days", "60 Days", "90 Days"],
                            }}
                            series={[
                                {
                                    name: "Existing",
                                    data: monthlyReport.map((d) => d.value![0]),
                                },
                                {
                                    name: "New",
                                    data: monthlyReport.map((d) => d.value![1]),
                                },
                                {
                                    name: "Service",
                                    data: monthlyReport.map((d) => d.value![2]),
                                },
                            ]}
                            type="radar"
                        />
                    </div>
                </div>

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    textAlign="center"
                >
                    <Stack direction="column">
                        <p className="text-muted mb-1">This Month</p>
                        <h3 className="mt-0 font-20">
                            <span className="align-middle">
                                {monthlyReport[0].value!.reduce(
                                    (a, v) => (a = a + v),
                                    0
                                )}{" "}
                            </span>{" "}
                            <small className="badge badge-soft-success font-12">
                                {(monthlyReport[0].value!.reduce(
                                    (a, v) => (a = a + v),
                                    0
                                ) /
                                    monthlyReport[1].value!.reduce(
                                        (a, v) => (a = a + v),
                                        0
                                    )) *
                                    100 -
                                    100}
                                %
                            </small>
                        </h3>
                    </Stack>

                    <Stack direction="column">
                        <p className="text-muted mb-1">Last Month</p>
                        <h3 className="mt-0 font-20">
                            <span className="align-middle">
                                {monthlyReport[1].value!.reduce(
                                    (a, v) => (a = a + v),
                                    0
                                )}
                            </span>{" "}
                            <small className="badge badge-soft-danger font-12">
                                {(monthlyReport[1].value!.reduce(
                                    (a, v) => (a = a + v),
                                    0
                                ) /
                                    monthlyReport[2].value!.reduce(
                                        (a, v) => (a = a + v),
                                        0
                                    )) *
                                    100 -
                                    100}
                                %
                            </small>
                        </h3>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
